module.exports = "/_next/static/resources/photo-3-6801c5dcd552409e9216fef179ca6eed.jpg";